import React, { Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form, Text, Checkbox, Select } from 'components/forms'
// import Button from 'components/Button'
import { ContentBlock } from 'components/ContentBlock'
import { useTranslation } from 'react-i18next'
import { loadAppConstants } from 'gql/query'

const Permissions = ({ data, formData, mutations: { updateItem } } = this.props) => {
	const [t, i18n] = useTranslation()
	const cancelationOptions = [
		{ value: '0', label: t('user_section.strings.no_bills') },
		{ value: '1', label: t('user_section.strings.owned_bills') },
		{ value: '2', label: t('user_section.strings.all_bills') }
	]
 	return(
		<ContentBlock>
			<Form smartSubmit initialValues={formData} onSubmit={updateItem} render={({ formApi, formState }) => (
				<Fragment>
					<Row>
						<Col xs>
							<Select
								field='cancelationPermissions'
								label={t('user_section.fields.cancellation_rights')}
								options={cancelationOptions}
							/>
							<Checkbox field='isFinStatements' label={t('user_section.fields.manual_closing')}/>
							<Checkbox field='isDayFinStatements' label={t('user_section.fields.day_closing')}/>
							<Checkbox field='isAdmin' label={t('user_section.fields.admin')}/>
						</Col>
						<Col xs>
							<Select
								field='typeRFID'
								label={t('user_section.fields.login_type')}
								remoteOptions={{ query: loadAppConstants, variables: { type: 31, language: i18n.language } }}
							/>
							<Checkbox field='isTimeTracking' label={t('user_section.fields.time_tracking_only')}/>
						</Col>
						{/*<Col xs>
							<p>TimeAssist</p>
							<Button status='primary' text='RFID KARTE ZUWEISEN'/>
						</Col>*/}
					</Row>
					<p className='form-group-label'>{t('user_section.strings.gastro')}</p>
					<Checkbox field='isManager' label={t('user_section.fields.manager')}/>
					<Checkbox field='isViewSales' label={t('user_section.fields.no_sale')}/>
					<Checkbox field='isOnlyNonManagerTables' label={t('user_section.fields.isOnlyNonManagerTables')}/>
					<Text field='codeExtern' label={t('user_section.fields.code_extern')} />
				</Fragment>
			)}/>
		</ContentBlock>
	)
}

export default Permissions
